import React from 'react';
import { useAutoSizeText } from 'js/components/popups/GamesInfoPopup/components/GameInfo/hooks';
import style from './Title.scss';

export const Title = ({ children, className = '' }) => {
    const { containerRef, textRef } = useAutoSizeText();

    return (
        <div className={`${className} ${style.gameTitle}`} ref={containerRef}>
            {/* H2 tag is a temporary solution according to https://jira.playtech.com/browse/SC-6519 */}
            <h2 ref={textRef}>{children}</h2>
        </div>
    );
};
